/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">© 2019 <b><a href="https://artisticvisions.com" target="_blank">Artistic Visions </a></b> LLC</span>
    <div class="">
      <a class="px-3" routerLink="legal/terms">Terms and Conditions</a>
      <a class="px-3" routerLink="legal/policy">Privacy Policy</a>
    </div>
  `,
})
export class FooterComponent {
}
